import { useState } from 'react';
// @mui
import { InputBase } from '@mui/material';
// components
import useChatClient from 'src/hooks/useChatClient';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

export default function ChatMessageInput() {
  const { t } = useTranslation('translation');
  const {
    activeConversation: conversation,
    pendingChat,
    sendMessage,
  } = useChatClient();
  const isArchived = !!conversation?.archived;
  const isPending = !conversation && !!pendingChat;
  const disabled = (!conversation && !isPending) || isArchived;

  const [message, setMessage] = useState('');

  const handleSend = (event) => {
    if (event.key === 'Enter') {
      if (message && (conversation || isPending)) {
        sendMessage(conversation?.id || null, message);
      }
      setMessage('');
    }
  };

  return (
    <InputBase
      value={message}
      onKeyUp={handleSend}
      onChange={(event) => setMessage(event.target.value)}
      placeholder={t('chat.type-a-message')}
      disabled={disabled}
      sx={{
        pl: 2,
        height: 56,
        flexShrink: 0,
        borderTop: (theme) => `solid 1px ${theme.palette.divider}`,
      }}
    />
  );
}
